import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import SettingsBudgetForecastSettingsIndexPage from 'lumen/components/settings/budget-forecast/settings-index-page';
import type HotelSettingsBudgetIndexRoute from 'lumen/routes/hotel/settings/budget/index';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsBudgetIndexSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsBudgetIndexRoute>;
  };
}

<template>
  <SettingsBudgetForecastSettingsIndexPage
    @entries={{or @model.entries.last.value (array)}}
    @isLoading={{@model.entries.isRunning}}
    @view="budget"
  />
</template> satisfies TOC<HotelSettingsBudgetIndexSignature>;
